import helpers from '@/store/helpers'
import Promise from 'promise-polyfill'

const Organization = {
  namespaced: true,
  state: {
    items: null,
    authItems: null
  },
  mutations: {
    load (state, payload) {
      state.items = Object.assign([], payload)
    },
    loadAuth (state, payload) {
      state.authItems = Object.assign([], payload)
    },
    reset (state, payload) {
      state.items = null
      state.authItems = null
    }
  },
  actions: {
    refresh: (context, payload) => helpers.refresh(context, payload,
      {backend: 'organization', method: 'getOrganizationsUsingGET', mutation: 'load', state: 'items'}),
    list: (context, payload) => helpers.list(context, payload, {action: 'refresh', state: 'items'}),
    refreshAuthorizedList: (context, payload) => helpers.refresh(context, payload,
      {backend: 'organization', method: 'getOrganizationsAuthUsingGET', mutation: 'loadAuth', state: 'authItems'}),
    listAuthorized: (context, payload) => helpers.list(context, payload, {action: 'refreshAuthorizedList', state: 'authItems'}),
    getAuthorizedOrgById: (context, payload) => {
      return new Promise((resolve, reject) => {
        context.dispatch('listAuthorized', payload).then(res => {
          const org = context.state.authItems.find(x => x.id === payload.id)
          if (typeof org !== 'undefined') {
            resolve(org)
          } else {
            reject(new Error('Organization ' + payload.id + ' not found'))
          }
        })
          .catch(err => reject(err))
      })
    },
    reset: (context, payload) => context.commit('reset')
  },
  getters: {
    loaded: (state) => state.items !== null
  }
}

export default Organization



// WEBPACK FOOTER //
// ./src/store/master/Organization.js